import { useShopAvailability } from "../shopAvailability";
import React, { useRef } from "react";
//Redux
import { useDispatch } from "react-redux";
import { removeProductCart, updateProductCart } from "./../../reducers/userConfigSlice";
//Styles
import { LuMinus, LuPlus } from "react-icons/lu";

export const CartActions = ({
  data,
  disabled = false,
  showAdd = true,
  addLabel,
  addQuantity = 1,
  singleSubmit = false,
  showRemove = true,
  showCounter = true,
  itemIds = [],
  variantId = null,
  note = "",
  callbackAction = () => null,
}) => {
  const dispatch = useDispatch();
  const adding = useRef(false);
  const { canOrder, check } = useShopAvailability();

  const addCart = async () => {
    if (disabled || !canOrder || adding.current) return;
    adding.current = true;
    if (!await check()) { adding.current = false; return; }
    const payload = {
      key: data.key,
      cartLineId: data.Product ? data.id : null,
      productId: data.productId || data.Product?.productId,
      itemIds: data.Product ? data.itemIds || [] : itemIds,
      variantId: data.Product ? data.variantId : variantId,
      note: data.Product ? data.note || "" : note,
      Product: data.Product || data,
    };
    dispatch(updateProductCart({...payload, quantityToAdd: addQuantity}));
    callbackAction(addQuantity);
    if (!singleSubmit) adding.current = false;
  };

  const removeFromCart = async () => {
    if (disabled) return;
    const payload = {
      key: data.key,
      cartLineId: data.Product ? data.id : null,
      productId: data.productId || data.Product?.productId,
      itemIds: data.Product ? data.itemIds || [] : itemIds,
      variantId: data.Product ? data.variantId : variantId,
      note: data.Product ? data.note || "" : note,
    };
    dispatch(removeProductCart(payload));
    callbackAction(-11);
  };
  return (
    <>
      {showRemove && (
        <button type="button" className="buttonCatalog" disabled={disabled} aria-label={`Quitar una unidad de ${data.Product?.name || data.name || "producto"}`} onClick={removeFromCart}>
          <LuMinus aria-hidden="true" />
        </button>
      )}
      {showCounter && (
        <div className="product-name" style={{ fontSize: "1.1rem" }}>
          {data.quantity}
        </div>
      )}
      {showAdd && (
        <button type="button" className="buttonCatalog" disabled={disabled || !canOrder} title={!canOrder ? "Pedidos no disponibles en este momento" : undefined} aria-label={`Añadir ${addQuantity === 1 ? "una unidad" : `${addQuantity} unidades`} de ${data.Product?.name || data.name || "producto"}`} onClick={addCart}>
          {addLabel || <LuPlus aria-hidden="true" />}
        </button>
      )}
    </>
  );
};
